import React, { useContext, useEffect } from "react"
import { graphql } from "gatsby"
import "reset-css"
import styled from "styled-components"

import { UserContext } from "../components/global-context"

import Intro from "../components/homepage/intro"
import Clients from "../components/homepage/clients-slider"
import ProjectsSlider from "../components/homepage/featured-projects/"

const PageContainer = styled.div`
  width: 100%;
  overflow: hidden;
`

const IndexPage = props => {
  const globalContext = useContext(UserContext)

  const data = {
    intro: {
      introTextImage:
        props.data.wpPage.homeFields.introText.localFile.publicURL,
      introVisual: {
        visualType: props.data.wpPage.homeFields.introVisual.visualType,
        image: props.data.wpPage.homeFields.introVisual.image,
        videoUrl: props.data.wpPage.homeFields.introVisual.videoUrl,
      },
    },
    clients: {
      logoTop: props.data.wpPage.homeFields.clients.logoTop.localFile.publicURL,
      logoBottom:
        props.data.wpPage.homeFields.clients.logoBottom.localFile.publicURL,
    },
  }

  useEffect(() => {
    globalContext.setValue("#c6c5c6")
  }, [globalContext])

  return (
    <PageContainer>
      <Intro {...data.intro} />

      <ProjectsSlider projects={props.data.allWpPost.edges} />

      <Clients {...data.clients} />
    </PageContainer>
  )
}

export const query = graphql`
  query HomePageQuery {
    wpPage(id: { eq: "cG9zdDoxMTM=" }) {
      homeFields {
        introText {
          localFile {
            publicURL
          }
        }

        introVisual {
          visualType
          videoUrl
          image {
            localFile {
              childImageSharp {
                fluid(maxWidth: 1200, quality: 100) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }

        clients {
          logoTop {
            localFile {
              publicURL
            }
          }

          logoBottom {
            localFile {
              publicURL
            }
          }
        }
      }
    }

    allWpPost(
      filter: { portfolio_item: { featured: { eq: true } } }
      sort: { fields: date }
    ) {
      edges {
        node {
          slug
          portfolio_item {
            previewGallery {
              layoutKind
              images {
                videoUrl
                visualType
                image {
                  localFile {
                    childImageSharp {
                      fluid(maxWidth: 1200, quality: 75) {
                        ...GatsbyImageSharpFluid_withWebp_noBase64
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export default IndexPage
